﻿@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';

.printed-section {
  h4 {
    margin: @space-0 @space-0 @space-16;
    font-weight: 500;
  }
  gap: @space-0;
}
.dropdown-option-wrapper {
  width: 100%;
  min-width: 240px;
  max-width: ~'fit-content';
  border-radius: @space-4;
  padding: @space-0;
}

.mobile-configuration-default-tote {
  input {
    width: 60px;
  }
}
